/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IOrderSchedulerViewProps } from './order-scheduler';
import { Node } from '@msdyn365-commerce-modules/utilities';

export default (props: IOrderSchedulerViewProps) => {
    const { datePicker, saveButtonProps, fieldLabelProps, orderScheduleWrapperProps, staticDisplay, shouldDisplayStatic } = props;
    return (
        <Node {...orderScheduleWrapperProps}>
            {shouldDisplayStatic ? (
                staticDisplay
            ) : (
                <React.Fragment>
                    <Node {...fieldLabelProps} key={'order-schedule-label'} />
                    {datePicker}
                    <Node {...saveButtonProps} key={'order-schedule-btn'} />
                </React.Fragment>
            )}
        </Node>
    );
};
